import {memo, useState} from "react";

import {useTeacherAccessPermissionsUpdatedListener} from "@khan/events-teacher-access-permissions";

import type {TeacherAccessPermissionsResult} from "./queries/use-teacher-access-permissions-query.ts";
import {TeacherAccessPermissionsContext} from "./teacher-access-permissions-context.ts";

interface Props {
    result: TeacherAccessPermissionsResult;
    children: React.ReactNode;
}

interface StateMutations {
    canPreviewLoggedOutTools?: boolean;
}

const TeacherAccessPermissionsContextProvider = (props: Props) => {
    const {result, children} = props;

    // Update the context value when the permissions change.
    const [stateMutations, setStateMutations] = useState<StateMutations>({});
    useTeacherAccessPermissionsUpdatedListener(({canPreviewLoggedOutTools}) => {
        setStateMutations({canPreviewLoggedOutTools});
    });

    // Combine the passed-in initial value with the state mutations.
    const combinedResult =
        result.status !== "success"
            ? result
            : {
                  ...result,
                  data: {
                      ...result.data,
                      ...stateMutations,
                  },
              };

    return (
        <TeacherAccessPermissionsContext.Provider value={combinedResult}>
            {children}
        </TeacherAccessPermissionsContext.Provider>
    );
};

export default memo(TeacherAccessPermissionsContextProvider);
